import React, { useState, useEffect } from "react";
import AdmissionRequirements from "../components/Courses/InformationTechnology/AdmissionRequirements";
import InformationTechnologyHeader from "../components/Courses/InformationTechnology/InformationTechnologyHeader";
import ITCareerSkillsSection from "../components/Courses/InformationTechnology/ITCareerSkills";
import ProgramDuration from "../components/Courses/Shared/ProgramDuration";
import ProgramBenefits from "../components/Courses/Shared/ProgramBenefits";
import StudentAcceptanceForm from "../components/Courses/Shared/StudentAcceptanceForm";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import cmsApi from "../services/cmsApi";

const INFORMATION_TECHNOLOGY_BENEFITS = [
  "High Demand, Guaranteed Relevance — Every industry today depends on technology. Skilled IT professionals are needed in hospitals, banks, schools, government offices, and businesses of all sizes — making this one of the most secure career choices you can make.",
  "Competitive Salaries — IT roles consistently offer some of the highest salaries in the job market, with clear pathways into senior, specialized, and management positions as your experience grows.",
  "Diverse Career Options — Your qualification opens doors to roles such as Network Administrator, IT Support Specialist, Database Administrator, Web Developer, Systems Analyst, and IT Security Officer.",
  "Structured, Credible Learning — Unlike self-taught pathways, a formal qualification from JRIIT gives you depth, structure, and credibility that employers recognize and respect.",
  "Future-Proof Skills — You will work with technologies shaping the future, including cloud computing, cybersecurity tools, programming, and data management systems.",
  "Problem-Solving Mindset — IT teaches you to think logically and solve real-world technical challenges — skills that are valuable in any workplace, not just in technology.",
];

const INFORMATION_TECHNOLOGY_CAREER_PATHS =
  "Graduates commonly go on to become Network Administrators, Web Developers, IT Security Specialists, Database Administrators, Systems Analysts, and IT Support Officers.";

const InfoTech = () => {
  const [pageComponents, setPageComponents] = useState({});
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);

  useEffect(() => {
    // Only fetch on client side to avoid hydration issues
    if (typeof window === 'undefined') return;

    const fetchPageData = async () => {
      try {
        setLoading(true);
        
        // Fetch all page components for Information Technology page
        const result = await cmsApi.getInformationTechnologyPageContent();
        
        if (result.success && result.components) {
          // Filter to only active components and organize by componentName
          const componentsMap = {};
          result.components
            .filter(comp => comp.isActive !== false) // Only show active components
            .forEach(comp => {
              componentsMap[comp.componentName] = comp;
            });
          setPageComponents(componentsMap);
        } else {
          console.warn('No page components found, using defaults');
        }
      } catch (error) {
        console.error('Error fetching Information Technology page data:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  // Show loading state (optional - you can remove this if you want to show default content immediately)
  if (loading && typeof window !== 'undefined') {
    return (
      <div>
        <Navbar />
        <div className="mid-desktop-page">
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-custom-pink border-t-transparent mx-auto mb-4"></div>
            <p className="text-gray-600">Loading Information Technology page...</p>
          </div>
        </div>
        </div>
        <Footer />
        <FloatingSocialPanels />
      </div>
    );
  }

  // Always render components - they have default content if CMS data is missing
  const headerComponent = pageComponents.header;
  const careerSkillsComponent = pageComponents['career-skills'];
  const admissionRequirementsComponent = pageComponents['admission-requirements'];

  return (
    <div>
      <Navbar />
      <div className="mid-desktop-page">
      {/* Hero Section - Always render with defaults if no CMS data */}
      <InformationTechnologyHeader componentData={headerComponent} />
      {/* Career Skills Section - Always render with defaults if no CMS data */}
      <ITCareerSkillsSection componentData={careerSkillsComponent} />
      {/* Course Duration */}
      <ProgramDuration />
      {/* Why Choose Information Technology at JRIIT? */}
      <ProgramBenefits
        programName="Information Technology"
        benefits={INFORMATION_TECHNOLOGY_BENEFITS}
        careerPaths={INFORMATION_TECHNOLOGY_CAREER_PATHS}
      />
      {/* Admission Requirements Section - Always render with defaults if no CMS data */}
      <AdmissionRequirements componentData={admissionRequirementsComponent} />
      {/* Student Acceptance Form */}
      <StudentAcceptanceForm programName="Information Technology" />
      <FullScreenImage />
      </div>
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default InfoTech;
